export default __webpack_public_path__ + "static/media/032-lemur.e12cfec2.svg";